import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Size } from '../../orders/order.model';
import { Promotion } from '../../promotions/promotion';

@Component({
  selector: 'app-size-price',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './size-price.component.html',
  styleUrls: ['./size-price.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SizePriceComponent {
  readonly size = input.required<Size>();
  readonly promotion = input<Promotion | undefined>();
  readonly isEditing = input<boolean>(false);
  readonly index = input<number>();
  readonly sizeChange = output<Size>();
  readonly remove = output<number>();
  readonly promotionClick = output<Size>();

  onWidthChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const updatedSize: Size = { ...this.size(), width: Number(target.value) || 0 };
    this.sizeChange.emit(updatedSize);
  }

  onHeightChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const updatedSize: Size = { ...this.size(), height: Number(target.value) || 0 };
    this.sizeChange.emit(updatedSize);
  }

  onPriceChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const updatedSize: Size = { ...this.size(), price: Number(target.value) || 0 };
    this.sizeChange.emit(updatedSize);
  }

  onMostPopularChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const updatedSize: Size = { ...this.size(), mostPopular: target.checked };
    this.sizeChange.emit(updatedSize);
  }

  onRemove() {
    if (this.index() !== undefined) {
      this.remove.emit(this.index() as number);
    }
  }

  onPromotionClick() {
    this.promotionClick.emit(this.size());
  }

  // Add helper method for date display
  formatDateDisplay(dateString: string): string {
    const date = new Date(dateString + 'T00:00:00'); // Add time to avoid timezone issues
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
}
